<!--
 * @Author: yangbobolaa 994786855@qq.com
 * @Date: 2024-03-04 15:10:12
 * @LastEditors: yangbobolaa 994786855@qq.com
 * @LastEditTime: 2024-04-29 14:22:04
 * @FilePath: \backend\src\views\pddLogistics\config\List.vue
 * @Description: 商家中心 -- 拼多多管理 -- 物流配置列表
-->
<template>
  <y-view :loading="isLoading">
    <y-card>
      <query-form :data="formData" :form="dataForm.query" @search="handleSearch" @reset="handleReset"></query-form>
      <query-table ref="yTable" :initColumns="initColumns" :dataForm="dataForm" :handleList="handleList" @loadingClose="isLoading = false" @loadingOpen="isLoading = true"></query-table>
    </y-card>
    <!-- 新增/编辑物流配置信息区域 start -->
    <k-popup bind="v-if" okText="提交" title="物流配置信息" :show.sync="isShowPopup" @after-ok="onSave" class="invite-container">
      <div style="width: 650px;">
        <y-form titleAlign="right" style="align-items: center;" titleWidth="60px" contentWidth="440px">
          <y-form-item title="店铺名称:" required>
            <k-select2
              v-if="!editPara.id && shopList.length > 1"
              block
              clearable
              :data="shopList"
              v-model="editPara.shopIdList"
              text-field="shopName"
              search-field="shopName"
              key-field="shopId"
              layer-width="440px"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择"
            >
            </k-select2>
            <k-select v-model="editPara.shopId" block placeholder="请选择" disabled v-if="!editPara.id && (shopList.length === 1 || shopList.length === 0)">
              <k-option v-for="item in shopList" :value="item.shopId" :key="item.shopId" :label="item.shopName" :selected="item.shopId == editPara.shopId">{{ item.shopName }}</k-option>
            </k-select>
            <k-input v-if="editPara.id" placeholder="请输入" :class="css.popup_inputW" v-model="editPara.shopName" disabled></k-input>
          </y-form-item>
          <y-form-item title="关区名称:" required>
            <k-select placeholder="请选择" :class="css.popup_inputW" clearable v-model="editPara.customsDictCode" v-if="!editPara.id">
              <k-option v-for="item in customsList" :key="item.code" :value="item.code" :label="item.pddName">{{ item.pddName }}</k-option>
            </k-select>
            <k-input v-else placeholder="请输入" :class="css.popup_inputW" v-model="editPara.customsDictName" disabled></k-input>
          </y-form-item>
          <y-form-item title="快递公司:" required>
            <k-select placeholder="请选择" :class="css.popup_inputW" clearable v-model="editPara.pddWpCode" v-if="!editPara.id">
              <k-option v-for="item in logisticsCompanyList" :key="item.pddWpCode" :value="item.pddWpCode" :label="item.logisticsCompanyName">{{ item.logisticsCompanyName }}</k-option>
            </k-select>
            <k-input v-else placeholder="请输入" :class="css.popup_inputW" v-model="editPara.logisticsCompanyName" disabled></k-input>
          </y-form-item>
          <y-form-item title="优先级:" required>
            <k-input placeholder="请输入>0的整数" :class="css.popup_inputW" v-model="editPara.sort" clearable maxlength="7"></k-input>
          </y-form-item>
          <y-form-item title="是否共享电子面单:" required v-if="isUseShare">
            <k-select placeholder="请选择" :class="css.popup_inputW" v-model="editPara.useShare">
              <k-option v-for="item in useShareList" :selected="editPara.useShare == item.value" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="快递切换设置:" required>
            <k-select placeholder="请选择" :class="css.popup_inputW" v-model="editPara.isManualSwitchLogistics">
              <k-option :selected="editPara.isManualSwitchLogistics === '1'" value="1" label="手动">手动</k-option>
              <k-option :selected="editPara.isManualSwitchLogistics === '0'" value="0" label="自动">自动</k-option>
            </k-select>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 新增/编辑物流配置信息区域 end -->
  </y-view>
</template>
<script>
import {
  MALL_LISTAUTHSHOP,
  COMMON_LIST_CUSTOMS,
  COMMON_WAYBILL_SUPPORT_SHARE,
  MALL_SHOP_WAYBILL_SETTING_PAGE,
  COMMON_LIST_LOGISTICS_BY_CUSTOMS,
  MALL_SHOP_WAYBILL_SETTING_CREATE,
  MALL_SHOP_WAYBILL_SETTING_DELETE,
  MALL_SHOP_WAYBILL_SETTING_UPDATE,
  MALL_SHOP_WAYBILL_SETTING_DETAIL,
} from "@/assets/modules/pinduooApiList";
import common from "@/assets/modules/util/common";
const initEditPara = () => ({
  id: "", //ID
  shopId: "",
  shopIdList: [], //店铺编码列表
  shopName: "", //店铺名称
  customsDictCode: "", //海关关区编码
  customsDictName: "", //海关关区名称
  pddWpCode: "", //拼多多物流公司编码
  logisticsCompanyName: "", //拼多多物流公司名称
  useShare: "0", //是否共享电子面单
  sort: "", //优先级
  isManualSwitchLogistics: "", //是否手动切换快递
});
export default {
  data() {
    return {
      isSaving: false,
      isLoading: false,
      isUseShare: false,
      isShowPopup: false,
      shopList: [], //店铺名称列表
      customsList: [], //关区名称列表
      logisticsCompanyList: [], //快递公司列表
      useShareList: [],
      editPara: initEditPara(),
      roleType: "", //'01':平台运营， '02':供应商, '03':分销商, '04':仓储， '05':服务商
      formData: [
        { typeCode: "select", title: "是否共享电子面单", name: "useShare", placeholder: "请选择", kname: "value", vname: "name", optionData: [] },
        { typeCode: "select2", title: "店铺名称", name: "shopIdList", placeholder: "请选择", vname: "shopName", kname: "shopId", sname: "shopName", optionData: [] },
        { typeCode: "select2", title: "关区名称", name: "customsDictCodeList", placeholder: "请选择", vname: "pddName", kname: "code", sname: "pddName", optionData: [] },
        { typeCode: "select", title: "快递公司", name: "wpCode", placeholder: "请选择", kname: "pddWpCode", vname: "logisticsCompanyName", optionData: [] },
        { typeCode: "select", title: "快递切换设置", name: "isManualSwitchLogistics", placeholder: "请选择", kname: "value", vname: "name", optionData: [
            { value: '1', name: '手动' },
            { value: '0', name: '自动' }
          ] },
      ],
      dataForm: {
        baseUrl: window.__CONFIG__.pinduoo_url,
        url: MALL_SHOP_WAYBILL_SETTING_PAGE,
        tableH: "calc(100vh - 258px)",
        rightFixedNumber: 1,
        query: { shopIdList: [], customsDictCodeList: [], wpCode: "", useShare: "", isManualSwitchLogistics: "" }, //列表查询条件字段
      },
      handleList: [{ type: "add", name: "新建", btnType: "primary", btnClick: (val) => this.handleLinkToDetail({}, 1) }],
      formRules: {
        shopIdList: [{ required: true, message: "店铺名称不能为空" }],
        customsDictCode: [{ required: true, message: "关区名称不能为空" }],
        pddWpCode: [{ required: true, message: "快递公司不能为空" }],
        sort: [{ required: true, message: "优先级不能为空" }],
        useShare: [{ required: true, message: "是否共享电子面单不能为空" }],
        isManualSwitchLogistics: [{ required: true, message: "快递切换设置不能为空" }],
      },
    };
  },

  watch: {
    "editPara.customsDictCode": {
      handler(nval) {
        if (!this.editPara.id) this.editPara.pddWpCode = "";
        if (nval) {
          this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: COMMON_LIST_LOGISTICS_BY_CUSTOMS, para: { customsCode: nval } }).then((res) => {
            this.logisticsCompanyList = res || [];
          });
        } else {
          this.logisticsCompanyList = [];
        }
      },
    },
    "editPara.pddWpCode": {
      handler(nval) {
        if (nval) {
          this.$fetch({
            baseUrl: window.__CONFIG__.pinduoo_url,
            api: COMMON_WAYBILL_SUPPORT_SHARE,
            para: { customsCode: this.editPara.customsDictCode, pddWpCode: nval },
          }).then((res) => {
            this.isUseShare = res;
            if (this.isUseShare === false) this.editPara.useShare = "0";
          });
        } else {
          this.isUseShare = false;
          this.editPara.useShare = "0";
        }
      },
    },
  },

  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格字段 */
    initColumns() {
      let tableItem = [
        { name: "店铺名称", style: this.tableStyle(150), customRender: (row) => <div>{row.shopName ? row.shopName : "——"}</div> },
        { name: "关区名称", style: this.tableStyle(150), customRender: (row) => <div>{row.customsDictName ? row.customsDictName : "——"}</div> },
        { name: "快递公司", style: this.tableStyle(150), customRender: (row) => <div>{row.logisticsCompanyName ? row.logisticsCompanyName : "——"}</div> },
        { name: "优先级", style: this.tableStyle(150), customRender: (row) => <div>{row.sort ? row.sort : "——"}</div> },
        { name: "是否共享电子面单", style: this.tableStyle(150), customRender: (row) => <div>{row.useShare === 1 ? "是" : row.useShare === 0 ? "否" : "——"}</div> },
        { name: "被共享店铺", style: this.tableStyle(150), customRender: (row) => <div>{row.shareShopName ? row.shareShopName : "——"}</div> },
        { name: "快递切换设置", style: this.tableStyle(150), customRender: (row) => <div>{row.isManualSwitchLogistics === true  ? "手动" : row.isManualSwitchLogistics === false ? "自动" : "——"}</div> },
        {
          name: "操作",
          style: this.tableStyle(60),
          customRender: (row) => (
            <div>
              <a class="table-handle-text-color" href="javascript:;" onclick={() => this.handleLinkToDetail(row, 2)}>
                编辑&#12288;
              </a>
              <a class="table-handle-text-color" href="javascript:;" onclick={() => this.handleLinkToDetail(row, 3)}>
                删除
              </a>
            </div>
          ),
        },
      ];
      return tableItem;
    },

    /** 物流配置删除操作 */
    onHandleDelete(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认执行当前操作？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: MALL_SHOP_WAYBILL_SETTING_DELETE, para: { id: row.id } })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.$refs.yTable.reload();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 获取物理配置详情信息 */
    getDetail(row) {
      this.isLoading = true;
      this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: MALL_SHOP_WAYBILL_SETTING_DETAIL, para: { id: row.id } })
        .then((res) => {
          this.isLoading = false;
          this.editPara.id = res.id;
          this.editPara.sort = res.sort;
          this.editPara.shopName = res.shopName;
          this.editPara.useShare = res.useShare;
          this.editPara.shopIdList = [res.shopId];
          this.editPara.pddWpCode = res.pddWpCode;
          this.editPara.customsDictCode = res.customsDictCode;
          this.editPara.customsDictName = res.customsDictName;
          this.editPara.logisticsCompanyName = res.logisticsCompanyName;
          this.editPara.isManualSwitchLogistics = Number(res.isManualSwitchLogistics) + '';
          this.isShowPopup = true;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 点击新建/编辑/删除操作 */
    async handleLinkToDetail(row, showType) {
      // showType 1:新建，2:编辑，3:删除
      switch (showType) {
        case 1:
          this.editPara = initEditPara();
          if (this.roleType === "03") {
            this.editPara.shopId = this.shopList[0].shopId;
            this.editPara.shopIdList = [this.shopList[0].shopId];
          }
          const customer = await this.$lf.getItem("customer");
          if (customer && customer.supplierUserInfoVO) this.editPara.supplierCompanyCode = customer.supplierUserInfoVO.companyCode;
          this.isShowPopup = true;
          break;
        case 2:
          this.editPara = initEditPara();
          this.getDetail(row);
          break;

        default:
          this.onHandleDelete(row);
          break;
      }
    },

    /** 保存物流配置信息 */
    onSave() {
      let para = JSON.parse(JSON.stringify(this.editPara));
      let isValidateSucc = common.formValidate(this, this.formRules, para);
      if (!isValidateSucc || this.isSaving) return;
      if (!/^\+?[1-9]\d*$/.test(para.sort)) return this.$root.tip("优先级只能输入大于0的正整数", "error");
      if (!para.id) delete para.id;
      let params = {};
      if (para.id) {
        params = { id: para.id, sort: para.sort, useShare: para.useShare, isManualSwitchLogistics: para.isManualSwitchLogistics ? Number(para.isManualSwitchLogistics) : '' };
      } else {
        params = { shopIdList: para.shopIdList, customsDictCode: para.customsDictCode, pddWpCode: para.pddWpCode, sort: para.sort, useShare: para.useShare, isManualSwitchLogistics: para.isManualSwitchLogistics ? Number(para.isManualSwitchLogistics) : '' };
      }
      this.isLoading = true;
      this.isSaving = true;
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api: para.id ? MALL_SHOP_WAYBILL_SETTING_UPDATE : MALL_SHOP_WAYBILL_SETTING_CREATE,
        para: params,
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.isShowPopup = false;
          this.$root.tip("操作成功", "success");
          this.$refs.yTable.init();
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },

    /** 根据条件搜索列表数据 */
    handleSearch(params) {
      this.isLoading = true;
      this.dataForm.query = {
        ...params,
        isManualSwitchLogistics: params.isManualSwitchLogistics ? Number(params.isManualSwitchLogistics) : ''
      };
      this.$refs.yTable.reload();
    },

    /** 重置列表查询条件 */
    handleReset() {
      this.isLoading = true;
      this.dataForm.query.shopIdList = [];
      this.dataForm.query.customsDictCodeList = [];
      this.$refs.yTable.reload();
    },

    /** 初始化页面数据 */
    initData() {
      // 获取角色类型
      this.$lf.getItem("menu").then((res) => {
        this.roleType = res.currentRoleType.roleTypeCode || "";
      });
      this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: MALL_LISTAUTHSHOP, para: {} }).then((res) => {
        this.shopList = res || [];
        this.formData.filter((item) => item.name === "shopIdList")[0].optionData = res || [];
      });
      this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: COMMON_LIST_CUSTOMS, para: {} }).then((res) => {
        this.customsList = res || [];
        this.formData.filter((item) => item.name === "customsDictCodeList")[0].optionData = res || [];
      });
      this.$fetch({ baseUrl: window.__CONFIG__.pinduoo_url, api: COMMON_LIST_LOGISTICS_BY_CUSTOMS, para: { customsCode: "" } }).then((res) => {
        this.formData.filter((item) => item.name === "wpCode")[0].optionData = res || [];
      });
      this.formData.filter((item) => item.name === "useShare")[0].optionData = [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
      ];
      this.useShareList = [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
      ];
    },
  },

  created() {
    this.initData();
    this.isLoading = true;
  },

  beforeRouteUpdate(to, from, next) {
    this.isLoading = true;
    this.$refs.yTable.refresh();
    next();
  },
};
</script>
<style module="css" lang="postcss">
.popup_inputW {
  width: 440px !important;
}
</style>
